export default {
  min: (val) => `En az ${val} karakter olmalıdır`,
  mustBigChar: 'En az bir büyük karakter içermelidir.',
  mustLowChar: 'En az bir küçük karakter içermelidir.',
  mustNumber: 'En az bir numara içermelidir.',
  mustMsisdn: 'Telefon numarası olmalıdır.',
  mustAlphabetic: 'Harflerden oluşmalıdır.',
};
